
import Login from "../contents/member/login/Login";
import FindPage from "../contents/member/login/FindPage";
import JoinPage from "../contents/member/join/JoinPage";
import JoinStep1 from "../contents/member/join/JoinStep1";
import JoinStep2 from "../contents/member/join/JoinStep2";
import JoinStep3 from "../contents/member/join/JoinStep3";
import JoinStep4 from "../contents/member/join/JoinStep4";
import Emog_popup from "../contents/member/join/Emog_popup";

import CheckPlusSuccess from "../contents/member/join/CheckPlusSuccess";
import CheckPlusFail from "../contents/member/join/CheckPlusFail";

const MemberPages =  [
    { path: '/member/login.do', titlename: '로그인', comp: <Login/> },
    { path: '/member/findPage.do', titlename: '아이디/비밀번호 찾기', comp: <FindPage/> },
    { path: '/member/joinPage.do', titlename: '회원가입 페이지', comp: <JoinPage/> },
    { path: '/member/joinStep1.do', titlename: '회원가입-약관동의', comp: <JoinStep1/> },
    { path: '/member/joinStep2.do', titlename: '회원가입-본인확인', comp: <JoinStep2/> },
    { path: '/member/joinStep3.do', titlename: '회원가입-가입정보입력', comp: <JoinStep3/> },
    { path: '/member/joinStep4.do', titlename: '회원가입-가입완료', comp: <JoinStep4/> },
    { path: '/member/emog_popup.do', titlename: '회원가입-기관정보검색', comp: <Emog_popup/> },
    { path: '/member/checkplus_success.do', titlename: '회원가입-본인확인-성공', comp: <CheckPlusSuccess/> },
    { path: '/member/checkplus_fail.do', titlename: '회원가입-본인확인-실패', comp: <CheckPlusFail/> },
]

export default MemberPages;